import "./Hero.scss";

import HeroStar from "../../assets/images/hero-star.svg";
import Button from "../../components/shared/Button";

export default function Hero() {
	return (
		<>
			<div className="hero" id="heading">
				<div className="hero-content-wrapper content-wrapper-lg">
					<div className="hero-content">
						<h1 className="hero-title" data-aos="zoom-in">
							<span>ChainCompute</span>
							<span className="highlight">
								AI
								<img
									className="hero-star"
									src={HeroStar}
									alt="Hero Star"
								/>
							</span>
						</h1>

						<p
							className="hero-desc"
							data-aos="fade-up"
							data-aos-delay="100"
						>
							ChainCompute AI combines public cloud flexibility
							with private cloud security for efficient,
							cost-effective AI processing. Utilizing GPUs, TPUs,
							and blockchain, it ensures seamless AI task
							execution with data privacy and integrity,
							empowering users to scale and optimize securely.
						</p>

						<div
							className="hero-btns"
							data-aos="fade-up"
							data-aos-delay="200"
						>
							<div className="hero-btn-wrapper pulse-effect">
								<Button className="hero-btn">
									Unlock Chain DAPP
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
